const host = {
  dev: 'http://11.141.33.195', // 获取语言包接口由pl接口 http://9.208.69.124:8080 改为tkex接口 http://11.141.33.195/
  prod: {
    hk: 'http://9.131.153.143',
    sg: 'http://30.46.123.94',
  }, // 获取语言包接口由pl接口 http://9.208.68.50:8080 改为tkex接口 9.131.153.143（香港）30.46.123.94(新加坡)
};

module.exports = {
  host,
};
